import { Icon } from '@iconify/react'
import SectionCard from '../../shared/SectionCard'
import './style.css'
import { CRRender, Image } from '@/components/crRender'
import { Validations } from '@/utils/validations'
import ImgPopup from '@/components/popups/imgPopup'
import { useRef, useState } from 'react'

const APILINK = window.API_URL

const AdvancedTechnologies = ({ technologies }) => {

    const imgPopupRef = useRef(null)

    const [img, setImg] = useState("")

    const handleOpenImgPopup = (img) => {
        setImg(img)
        imgPopupRef.current?.click()
    }


    return (
        <>
            <CRRender isRender={!Validations.isArrayEmpty(technologies)}>

                <SectionCard icon="mdi:robot" titleKey="advanced-technologies">
                    <div className="technologies-grid">
                        {[...technologies]?.mapWithKey((tech) => (
                            <div key={tech.key} className="technology-card" onClick={() => handleOpenImgPopup(tech.attachmentPath)}>
                                <div className="technology-icon">
                                    <Image src={`${APILINK}${tech.attachmentPath}`} alt={tech.name} />
                                </div>
                                <div className="technology-content">
                                    <div className="technology-name">{tech.name}</div>
                                    <div className="technology-description">{tech.description}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </SectionCard>
            </CRRender>

            <ImgPopup sourcePath={APILINK} link={`${img}`} isHideText={true} refImg={imgPopupRef} />
        </>
    )
}

export default AdvancedTechnologies

